import { BaseController } from '../../common/base/controller';
import _ from 'lodash';
import { TransferModel } from './transfer.model';
import { TransferType, TransferOptions } from './transfer.constants';
import { OldBankModel } from '../oldPortfolio/bank.model';

export class TransferController extends BaseController {
  loading = false;

  get checkCreditorChange() {
    return this.configService.isFeatureActive(
      this.Features.checkCreditorChange,
    );
  }

  get guidedTourIsActive() {
    return this.appCache.get('guidedTourIsActive');
  }

  get iconPath() {
    return this.configService.getFeature(this.Features.infoIconPath);
  }

  get transferTypes() {
    return (
      this.configService.getFeature(this.Features.transferTypes) ||
      Object.keys(TransferType)
    );
  }

  get transferAllSecurities() {
    return this.appCache.get('transferAllSecurities');
  }

  get transferWithLogin() {
    return !this.transferAllSecurities && !this.creditorChange;
  }

  get tenantName() {
    return this.configService.getTenant();
  }

  constructor($scope, controllerService, securitiesService, configService) {
    'ngInject';
    super({
      $scope,
      controllerService,
      securitiesService,
      configService,
    });
  }

  get ownAccountTransferPrechecked() {
    return this.configService.isFeatureActive(
      this.Features.ownAccountTransferPrechecked,
    );
  }

  $onInit() {
    this.oldPortfolio = this.appCache.get('oldPortfolio');

    this.oldBank = this.appCache.get('oldBank') || new OldBankModel();

    this.transfer = this.appCache.get('transfer') || new TransferModel();
    this.transferOptions = _.filter(
      TransferOptions,
      (o) => this.transferTypes.indexOf(o.value) !== -1,
    ).map((option) =>
      _.merge(option, {
        type: 'radio',
        name: 'transfer-radio',
        iconPath: this.iconPath,
      }),
    );

    if (this.ownAccountTransferPrechecked) {
      this.transfer.type = this.transfer.type || TransferType.ownAccount;
      this.ownAccount = true;
    }

    this.$scope.$watch('vm.ownAccount', (newValue) => {
      this.transfer.type = newValue ? TransferType.ownAccount : null;

      // Stop transfer to next state for switch where ownAccount value is not truthy.
      if (this.checkCreditorChange) {
        this.creditorChange = !newValue;
      }
    });

    this.$scope.$watch('vm.transfer.type', (newValue) => {
      this.transferTypValid();
    });
  }

  nextWithLogin() {
    this.appCache.set('guidedTourIsActive', false);
    this.updateCache();
    this.startUBA();
  }

  nextWithoutLogin() {
    this.appCache.set('guidedTourIsActive', true);
    this.updateCache();
    this.nextState();
  }

  next() {
    this.updateCache();

    this.transferForm.$setSubmitted();
    if (!this.transferForm.$valid || !this.formValid()) {
      return;
    }

    this.nextState('app.owner');
  }

  prev() {
    this.updateCache();
    this.prevState();
  }

  startUBA() {
    this.loading = true;
    this.securitiesService.loginWithUBA().then(
      (response) => {
        let { redirectURL, sessionId, userIdentifier } = response.data;
        const redirectURLAfterUBA = `${this.$window.location.origin}/newPortfolio`;
        const exitURL = `${this.$window.location.origin}/transfer`;
        const service = 'dws';
        const tenant = this.tenantName.toLowerCase().replaceAll('_', '-');

        const { primaryColor, logo } = this.configService.config;

        const theme = encodeURIComponent(
          angular.toJson({
            primaryColor,
            logo,
          }),
        );

        const ubaUrl = [
          `${redirectURL}?sessionId=${sessionId}`,
          `userIdentifier=${userIdentifier}`,
          `redirectURL=${redirectURLAfterUBA}`,
          `exitURL=${exitURL}`,
          `service=${service}`,
          `tenant=${tenant}`,
          `theme=${theme}`,
          'accountTypes=DEPOT,FONDSDEPOT',
          'demoAccount=depot',
          'translateKey=dws',
        ].join('&');

        this.appCache.set('UBAUserIdentifier', userIdentifier);

        this.$window.location.href = ubaUrl;
      },
      () => {},
      () => (this.loading = false),
    );
  }

  updateCache() {
    this.transfer.ownAccountInfo =
      this.transfer.type === TransferType.ownAccount;

    if (this.transfer.type !== TransferType.ownAccount) {
      // Bei einem DWS mit Gläubigerwechsel, können keine Verlustverrechnungstöpfe (transferCapitalLoss) übertragen werden.
      this.oldPortfolio.transferCapitalLoss = false;
    }
    // apply checkbox from start page
    this.oldPortfolio.transferAllSecurities = this.transferAllSecurities;
    this.appCache.set('oldPortfolio', this.oldPortfolio);
    this.appCache.set('oldBank', this.oldBank);
    this.appCache.set('transfer', {
      ...this.transfer,
      type: this.transfer.type,
    });
  }

  transferTypValid() {
    if (this.transferForm.$submitted) {
      this.transferTypValidationError = !this.transfer.type;
    }
  }

  formValid() {
    this.oldBankNotSelectedError = !this.oldBank.legacyBankIdentifier;
    this.transferTypValid();
    return !this.transferTypValidationError && !this.oldBankNotSelectedError;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/transfer/transfer.controller.js